module.exports = __webpack_public_path__ + "static/media/4.ef6f8717.jpg";